import React, { useEffect } from "react";

import CloneChildren from "@components/children";

import { CommonProps } from "@utils/interface";
import { useOnload } from "@utils/useRunOnload";
import { PlansBottomBannerWrapper, AddonsContainer, UpNextLabel } from "./styles";
interface PlansBottomBannerInterface extends CommonProps {
  bannerText: string;
  addonsList: any[];
}

const PlansBottomBanner = ({
  children,
  ...props
}: PlansBottomBannerInterface) => {
  const { actions, id, is_visible } = props;
  const { on_load } = actions || {};
  const { addonsList } = props;
  useOnload({ id, on_load });

  const renderAddonsList = () => {
    if (!addonsList || addonsList.length === 0) {
      return null;
    }

    const firstTwo = addonsList.slice(0, 2);
    const remainingCount = addonsList.length - 2;
    const addonsText = firstTwo.map((addon) => addon.display_name).join(", ");

    if (addonsList.length > 2) {
      return (
        <p>
          <UpNextLabel>Up next:</UpNextLabel> {addonsText}
          <b> +{remainingCount} more additional covers</b>
        </p>
      );
    } else {
      return (
        <p>
          <UpNextLabel>Up next:</UpNextLabel> {addonsText}
        </p>
      );
    }
  };

  return is_visible && addonsList && addonsList.length > 0 ? (
    <PlansBottomBannerWrapper>
      <AddonsContainer>{renderAddonsList()}</AddonsContainer>
    </PlansBottomBannerWrapper>
  ) : null;
};

export default PlansBottomBanner;
